var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import React, { Component, Children, cloneElement, createRef } from "react";
import { findFirstTabbableIndex, findNextTabbableIndex, findPrevTabbableIndex, findLastTabbableIndex, findNextTabbaleIndexByChar } from "./utils";
import { Container, Point, Inner } from "./styled/menu-list";

var MenuList =
/** @class */
function (_super) {
  __extends(MenuList, _super);

  function MenuList() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.listRef = createRef();
    _this.menuRef = createRef();

    _this.handleOnKeyDown = function (e) {
      e.stopPropagation();
      var _a = _this.props,
          _b = _a.focusIndex,
          focusIndex = _b === void 0 ? -1 : _b,
          setFocusIndex = _a.setFocusIndex,
          onClose = _a.onClose,
          children = _a.children;

      if (e.key === "ArrowDown") {
        e.preventDefault();
        var nextIndex = findNextTabbableIndex(children, focusIndex);

        if (nextIndex === -1) {
          nextIndex = findFirstTabbableIndex(children);
        }

        setFocusIndex && setFocusIndex(nextIndex);
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        var prevIndex = findPrevTabbableIndex(children, focusIndex);

        if (prevIndex === -1) {
          prevIndex = findLastTabbableIndex(children);
        }

        setFocusIndex && setFocusIndex(prevIndex);
      } else if (e.key === "Home") {
        setFocusIndex && setFocusIndex(findFirstTabbableIndex(children));
      } else if (e.key === "End") {
        setFocusIndex && setFocusIndex(findLastTabbableIndex(children));
      } else if (e.key === "Tab") {
        e.preventDefault();
      } else if (e.key === "Escape") {
        onClose && onClose();
      } else {
        if (e.key.length === 1) {
          var index = findNextTabbaleIndexByChar(children, e.key, focusIndex);

          if (index !== -1) {
            setFocusIndex && setFocusIndex(index);
          } else {
            index = findNextTabbaleIndexByChar(children, e.key, -1);

            if (index !== -1) {
              setFocusIndex && setFocusIndex(index);
            }
          }
        }
      }
    };

    _this.handleOnMouseDown = function (e) {
      e.preventDefault();
    };

    _this.handleOnBlur = function (e) {
      var relatedTarget = e.relatedTarget || document.activeElement;

      if (!e.currentTarget.contains(relatedTarget)) {
        _this.props.onClose && _this.props.onClose(true);
      }
    };

    _this.setDirection = function () {
      var list = _this.listRef.current;

      if (list) {
        var listRect = list.getBoundingClientRect(); // If the menu goes past the window height, position it the other way

        if (listRect.y + listRect.height >= window.innerHeight) {
          list.classList.add("top");
          list.classList.remove("bottom");
        } else {
          list.classList.remove("top");
          list.classList.add("bottom");
        }
      }
    };

    return _this;
  }

  MenuList.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        focusIndex = _a.focusIndex,
        idRef = _a.idRef,
        showPoint = _a.showPoint,
        children = _a.children,
        onClose = _a.onClose;
    return React.createElement(Container, {
      className: className,
      ref: this.listRef,
      onKeyDown: this.handleOnKeyDown,
      onMouseDown: this.handleOnMouseDown,
      onBlur: this.handleOnBlur
    }, showPoint && React.createElement(Point, {
      className: "menu-point"
    }), React.createElement(Inner, {
      ref: this.menuRef,
      role: "menu",
      tabIndex: -1,
      "aria-labelledby": idRef,
      className: "menu-inner"
    }, Children.toArray(children).map(function (child, index) {
      if (!child) return null; // Using `any` here as I'm not sure how to target forwardRef components.
      // styled components will use forward ref so we have to drill into `el.type.target`

      var el = child;
      return cloneElement(el, {
        isFocused: focusIndex === index,
        onClose: onClose
      });
    })));
  };

  MenuList.prototype.componentDidMount = function () {
    var _a;

    var _b = this.props,
        focusIndex = _b.focusIndex,
        direction = _b.direction,
        setFocusIndex = _b.setFocusIndex,
        children = _b.children;
    this.setDirection();

    if (focusIndex === -1) {
      if (direction === "manual") {
        (_a = this.menuRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        return;
      }

      if (direction === "down") {
        setFocusIndex && setFocusIndex(findFirstTabbableIndex(children));
      } else if (direction === "up") {
        setFocusIndex && setFocusIndex(findLastTabbableIndex(children));
      }
    }
  };

  MenuList.defaultProps = {
    showPoint: true
  };
  return MenuList;
}(Component);

export default MenuList;